import { useState, type FormEvent } from 'react';
import { Alert, Box, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import type { ApiFallo } from '../lib/api.js';

export function Login({ onEntrar }: { onEntrar: () => void }) {
  const [password, setPassword] = useState('');

  const entrar = useMutation({
    mutationFn: () => api.login(password),
    onSuccess: onEntrar,
  });

  const fallo = entrar.error as ApiFallo | null;

  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '70vh' }}>
      <Paper sx={{ p: 4, width: '100%', maxWidth: 380 }}>
        <Stack
          component="form"
          spacing={2.5}
          onSubmit={(e: FormEvent) => {
            e.preventDefault();
            entrar.mutate();
          }}
        >
          <Box>
            <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 700 }}>
              film-downloader
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Introduce la contraseña de la aplicación.
            </Typography>
          </Box>

          <TextField
            type="password"
            label="Contraseña"
            size="small"
            autoFocus
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {fallo && (
            <Alert severity="error">
              {fallo.code === 'invalid_credentials' ? 'Contraseña incorrecta.' : fallo.message}
            </Alert>
          )}

          <Button type="submit" variant="contained" disabled={!password || entrar.isPending}>
            {entrar.isPending ? 'Entrando…' : 'Entrar'}
          </Button>

          <Typography variant="caption" color="text.secondary">
            Es la que pusiste en <code>APP_PASSWORD</code>.
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}
